<div [innerHtml]="helpText"></div>